<template>
    <div class="header" :style="styles">
        <heading :level="5">{{ surtitle }}</heading>
        <heading :level="2" v-html="header.title" />
        <paragraph size="M" :content="header.text" />
    </div>
</template>

<script>
import Heading from 'gvue/src/core/Heading'
import Paragraph from 'gvue/src/core/Paragraph'

export default {
    name: 'EditionHeader',
    components: {
        Heading,
        Paragraph
    },
    props: {
        category: { type: Object, required: true },
        current: { type: String, required: true },
        header: { type: Object, required: true }
    },
    computed: {
        surtitle() {
            return `${this.config.edition} ${this.current}`
        },
        config() {
            return this.$json.config
        },
        styles() {
            return {
                borderColor: this.category.color
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
.header
    padding: ($gap * 3.5) ($gap * 2.5)
    background-color: $color_background

.g_h2
    text-transform: none

.g_h5
    text-transform: uppercase

+mobile
    .header
        padding: ($gap * 0.5) ($gap * 1.25) ($gap * 1.75)
        background-color: $color_background
        border-left: 4px solid

    .g_h2
        margin-top: ($gap * 0.25)
        font-size: 1.5em
        letter-spacing: 0.15em
        line-height: 1.25
        text-transform: none

    .g_h5
        margin: 0
        font-weight: 600
        letter-spacing: 0.1em
        text-transform: uppercase

+desktop
    .g_h2
        margin-bottom: $gap

+desktop
    .header
        border-right: 8px solid

    .g
        .g_h2
            margin-bottom: 0.75em
</style>
